import Reveal from "@/components/site/Reveal";

const WORKSPACE_IMG =
  "https://images.unsplash.com/photo-1735948055457-8d816fb80a87?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHwxfHxzbGVlayUyMGRhcmslMjBhZXN0aGV0aWMlMjB3b3Jrc3BhY2V8ZW58MHx8fHwxNzc4MTc4NjMwfDA&ixlib=rb-4.1.0&q=85";

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-24 md:py-36"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16 items-center">
        <Reveal className="md:col-span-5 order-2 md:order-1" y={36}>
          <div className="relative aspect-[4/5] overflow-hidden rounded-2xl border border-white/10">
            <img
              src={WORKSPACE_IMG}
              alt="Sleek dark workspace"
              className="h-full w-full object-cover grayscale brightness-90 contrast-110 hover:grayscale-0 transition-all duration-700"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent" />
            <div className="absolute bottom-5 left-5 right-5 flex items-end justify-between">
              <div>
                <div className="font-mono-label text-[10px] text-violet-300/80">Operator</div>
                <div className="font-display text-2xl font-bold text-white">Max</div>
              </div>
              <div className="font-mono-label text-[10px] text-white/50 text-right">
                Maximilian
                <br />
                Marketing
              </div>
            </div>
          </div>
        </Reveal>

        <Reveal className="md:col-span-7 order-1 md:order-2" delay={120}>
          <div className="font-mono-label text-[11px] text-violet-400 mb-6">
            01 / About the studio
          </div>
          <h2
            data-testid="about-heading"
            className="font-display text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight leading-[1.05] text-white"
          >
            One designer. One developer.
            <br />
            <span className="text-white/60">Same person.</span>
          </h2>
          <div
            data-testid="about-body"
            className="mt-8 space-y-5 text-base md:text-lg text-white/70 leading-relaxed font-light"
          >
            <p>
              I'm <strong className="text-white font-semibold">Max</strong>, and{" "}
              <strong className="text-white font-semibold">Maximilian Marketing</strong> is my
              independent studio. No agency middlemen, no junior hand-offs — every brief lands
              directly on my desk and stays there until launch.
            </p>
            <p>
              I work with founders and growing companies to design and build{" "}
              <strong className="text-white font-semibold">custom websites</strong> that feel{" "}
              <strong className="text-white font-semibold">considered, fast, and unmistakably yours</strong>.
              No themes. No drag-and-drop builders. Real code, written for you.
            </p>
            <p className="text-white/55 text-sm md:text-base">
              I keep a small set of modern tools — including a touch of AI — close at hand to move
              quickly, but the taste, the typography, the details: those are mine.
            </p>
          </div>

          <div className="mt-10 grid grid-cols-2 gap-6 max-w-xl">
            {[
              { title: "Direct", body: "You talk to the person building the site. That's it." },
              { title: "Bespoke", body: "No templates. Designed around your brand and goals." },
              { title: "Fast", body: "Lean process. Sites ship in days, not quarters." },
              { title: "Modern", body: "Clean code, sharp design, performance baked in." },
            ].map((p, i) => (
              <Reveal key={p.title} delay={200 + i * 90} y={20}>
                <div className="border-l border-violet-500/40 pl-4">
                  <div className="font-display text-base font-bold text-white mb-1">{p.title}</div>
                  <div className="text-sm text-white/55 leading-relaxed">{p.body}</div>
                </div>
              </Reveal>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
